import _ from 'lodash';
import { FieldOption, FieldType } from '../../../types/FieldCommon';

export type FormFieldMetadata = {
  required?: boolean;
  description?: string;
};

export const typeOptions: FieldOption[] = [
  { label: 'Text', value: FieldType.STRING },
  { label: 'Multiline Text', value: FieldType.MULTILINE },
  { label: 'Number', value: FieldType.NUMBER },
  { label: 'Date', value: FieldType.DATE },
  { label: 'Date Time', value: FieldType.DATETIME },
  { label: 'Time', value: FieldType.TIME },
  { label: 'Selection', value: FieldType.AUTOCOMPLETE },
  { label: 'Multiple Selection', value: FieldType.MULTISELECT },
  { label: 'Checkbox', value: FieldType.CHECKBOX },
];

export const getFieldTypeLabel = (type: FieldType): string => _.find(typeOptions, (option) => option.value === type)?.label ?? '';
